import React, { FC } from 'react';
import { Button, HeadingThree, colors } from 'hui';
import { HeadingWrapper } from './style';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ViewAssessmentArea: FC<{}> = () => {
  const StyleLint = styled.span`
    color: ${colors.tint6};
  `;
  return (
    <>
      <HeadingWrapper>
        <HeadingThree>3. View added assessments</HeadingThree>
      </HeadingWrapper>
      <Button color="primary">
        <Link to={'/doe/assessments'}>
          <StyleLint>View Assessments</StyleLint>
        </Link>
      </Button>
    </>
  );
};

export default ViewAssessmentArea;
